import styled from "styled-components";
import { GREEN_RGB } from "utils/colorsTheme";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

export const ArrowUpwardIconStyled = styled(ArrowUpwardIcon)`
  color: ${GREEN_RGB};
`;
